<p-dialog [(visible)]="visible" [modal]="true" [style]="{width: '50vw', height: '80vh'}" class="custom-dialog"
  (onHide)="onDialogClose()">
  <div class="dialog-content-wrapper">
    <form [formGroup]="formGroup" class="form-container">
      <div class="form-left">
        <div class="p-grid form-content">
          <ng-content select="[form-fields]"></ng-content>
        </div>
      </div>
      <div class="form-right">
        <div class="title-container">
          <h3>{{ dialogTitle }}</h3>
        </div>
        <div class="divider"></div>
        <img [src]="imageSrc" alt="Imagem" class="dialog-image" />
        <div class="divider title-divider"></div>
        <div class="p-button-container">
          <button type="submit" pButton [label]="submitButtonLabel" [disabled]="formGroup?.invalid"></button>
          <button type="button" pButton label="Cancelar" (click)="onCancel()" class="p-button-secondary"></button>
        </div>
      </div>
    </form>
  </div>
</p-dialog>